import firebase from '@/firebase';
import db from '@/db';

import { UPDATE_SURVEY, SET_SURVEY_ID, RESET_SURVEY_ID, SET_LEAD_ID,
        SET_SURVEY_ANSWERS, UPDATE_ANSWERS, UPDATE_SURVEY_ANSWERS,
        UPDATE_SURVEY_SCORE, RESET_STATE } from './mutations';


const initialState = {
  survey: {
    email: "user@example.com",
    status: "started",
    currentPage: 1,
    quizList: [],
    extra: {
      created_at: new Date(),
      updated_at: firebase.firestore.FieldValue.serverTimestamp()

    },
  },
  docID: null
};

const state = Object.assign({}, initialState)


const getters = {
  survey: ({survey}) => survey,
  docID: ({docID}) => docID,
  categories: state => {
    // returns the list of categories
    // compute top scores too
    var catList = [];
    for (var categoryIdx in state.survey.quizList) {
      // Add the category to the result list
      let categoryObject = state.survey.quizList[categoryIdx];
      catList.push(
        {"name": categoryObject.title,
        "userScore": categoryObject.userScore,
        "maxScore": categoryObject.maxScore,
        "color": categoryObject.color
      });

      // let categoryTopScore = 0;
      // let categoryUserScore = 0;
      // for (var question in categoryObject.questions) {

      // }
    }
    return catList;
  },


  scores: state => {
    // returns the list of scores
    var scoreList = {};
    var maxScore = 0;
    var userScore = 0;
    for (var categoryIdx in state.survey.quizList) {
      // Add the category to the result list
      let categoryObject = state.survey.quizList[categoryIdx];
      scoreList[categoryObject.title.en] = (categoryObject.userScore/categoryObject.maxScore).toFixed(2);
      userScore += categoryObject.userScore;
      maxScore += categoryObject.maxScore;
    }
    scoreList["Global"] = (userScore/maxScore).toFixed(1) ;
    return scoreList;
  }
};

const mutations = {

  [UPDATE_SURVEY](state, info) {
    state.survey.email = info.email;
    state.survey.status = info.status;
    state.survey.currentPage = info.currentPage;
  },

  [UPDATE_ANSWERS](state, answers) {
    state.survey.quizList = answers;
  },

  [SET_SURVEY_ID](state, SurveyID) {
    state.docID = SurveyID;
  },

  [SET_SURVEY_ANSWERS](state, listQuiz) {
    // We take as input listQuiz and we add new fields
    // These new fields will be used to store the user answers/score

    state.survey.quizList = listQuiz;
    for (var categoryIdx in state.survey.quizList) {
      for (var questionIdx in state.survey.quizList[categoryIdx].questions) {
        var question = state.survey.quizList[categoryIdx].questions[questionIdx];
        question["userAnswer"] = null; // we add a new field userAnswer
        question["userScore"] = null; // we add a new field userAnswer
        question["maxScore"] = null; // we add a new field userAnswer
        question["inPageSeqId"] = questionIdx; // the order of the question on page

        // If we are in presence of a checkbox, then we add a 'checked' state:
        if (question.questionType == "Checkbox") {
          for (let answer of question.answers) {
            answer["checked"] = false;
          }
        }
      }
    }
  },

  [UPDATE_SURVEY_ANSWERS](state, payload) {
    // We update the user answer for ONE given question
    // payload = { 'page_number': 1, 'question_idx': 3, 'userAnswer': [...], 'question': {...}}
    state.survey.quizList[payload.page_number-1].questions[payload.question_idx].userAnswer = payload.userAnswer;

    // Update Score
    // ...
    var question = state.survey.quizList[payload.page_number-1].questions[payload.question_idx];
    var userAnswer = [];
    var userScore = 0;
    var maxScore = 0;

    for (let answer of question.answers) {
      if (answer.checked === true) {
        userAnswer.push(answer.answer);
        userScore += parseInt(answer.points) ;
      }
      if (question.questionType === "Radiogroup") {
        // If the question is a radioGroup, the max score is the max of all possible scores
        maxScore = Math.max(answer.points, maxScore);
      } else {
        // else, it means we can have several anwers, so we add them
        maxScore += parseInt(answer.points)
      }
    }
    question.userAnswer = userAnswer;
    question.userScore = userScore;
    question.maxScore = maxScore;
  },

  [UPDATE_SURVEY_SCORE](state) {
    // Once a question has been updated, we update the survey general scores
    for (let category of state.survey.quizList) {
      var maxScore = 0;
      var userScore = 0;
      for (let question of category.questions) {
        if (typeof question.maxScore !== "undefined"){
          maxScore += parseInt(question.maxScore);
          userScore += parseInt(question.userScore);
        }
      }
      category.maxScore = maxScore;
      category.userScore = userScore;
    }
  },

  [RESET_SURVEY_ID](state, SurveyID) {
    state.docID = null;
    state.survey = {
      email: "user@example.com",
      status: "started",
      current_page: 1,
      quizList: [],
      extra: {
        created_at: new Date(),
        updated_at: firebase.firestore.FieldValue.serverTimestamp()
      }
    };
  },

  [RESET_STATE](state) {
    let newState = initialState;
    state = Object.assign(state, newState);
  }
};

const actions = {


  async saveSurvey({state}) {
    // Save the profile in Firestore
    await db.collection('surveys').doc(state.docID).update({
            ...state.survey
          });
  },

  async getSurveyFromID({state, commit}, payload ) {

    // payload = {docID: "242rgr4F"}
    // Fetch and instantiate a given survey

    if (!payload.docID) {
      throw new Error('An ID is required to fetch the survey!');
    }

    const survey = await db.collection('surveys').doc(payload.docID).get();


    if (!survey.exists) {
      throw new Error('An ID is required to fetch the survey!');
    }
    // else {
    //   // the user has not add any survey yet, we create one for him
    //   var info = {"email": payload.email, "status": "started", "currentPage": 1};
    //   commit(UPDATE_SURVEY, info);
    //   commit(SET_SURVEY_ANSWERS, payload.quizList);

    //   const newDoc = await db.collection('surveys').add({
    //         ...state.survey
    //       });

    //   commit(SET_SURVEY_ID, newDoc.id);
    // }
    else
    {
      // 2 - the user exist in DB, we retrieve the data
      // We set all fields we got from the DB and let the other by default
      for(var key in survey.data()) {
          if(state.survey.hasOwnProperty(key)) {
            state.survey[key] = survey.data()[key];
          }
        }
      commit(SET_SURVEY_ID, survey.id);
    }

  },

  async getOrCreateSurvey({state, commit}, payload ) {

    // payload = {"email": payload.email, "quizList": payload.quizList, "createWithoutEmail": false}

    // 1 - we first check if the survey already exists locally. If yes, we return
    // 2 - otherwise we check if the survey is already existing on server and fetch existing info (potentially a problem: competitors could steal the data)
    // 3 - if it's the first time the user we copy the listQuiz into state.answers (this is what will be used for questions)
    // and we save into Firebase

    // 1 - if the user already has a SurveyID we get it, otherwise we create it
    if (state.docID !== null)
      return;

    var createWithoutEmail = false;
    if (payload.createWithoutEmail) {
      createWithoutEmail = payload.createWithoutEmail;
    }

    if (!payload.email && createWithoutEmail === false) {
      throw new Error('An email is required to create the survey!');
    }

    // If the survey needs to be created with an email
    if (createWithoutEmail === false) {
    const survey = await db.collection('surveys')
                            .where("email", "==", state.survey.email)
                            .orderBy('created_at', 'desc')
                            .limit(1)
                            .get();

      // 3 - Creation
      if (survey.docs.length == 0 || !survey.docs[0].exists) {
        console.log("This user doesn't have the quiz list localy, we create survey");
        // the user has not add any survey yet, we create one for him
        var info = {"email": payload.email, "status": "started", "currentPage": 1};
        commit(UPDATE_SURVEY, info);
        commit(SET_SURVEY_ANSWERS, payload.quizList);

        const newDoc = await db.collection('surveys').add({
              ...state.survey
            });

        commit(SET_SURVEY_ID, newDoc.id);
      }
      else
      {
        // 2 - the user exist in DB, we retrieve the data
        // We set all fields we got from the DB and let the other by default
        for(var key in survey.docs[0].data()) {
            if(state.survey.hasOwnProperty(key)) {
              state.survey[key] = survey.docs[0].data()[key];
            }
          }
        commit(SET_SURVEY_ID, survey.docs[0].id);
      }
    }
    // If the survey needs to be created without an email
    else {
      console.log("We create a survey without email address");
      // the user has not add any survey yet, we create one for him
      var info = {"email": null, "status": "started", "currentPage": 1};
      commit(UPDATE_SURVEY, info);
      commit(SET_SURVEY_ANSWERS, payload.quizList);

      const newDoc = await db.collection('surveys').add({
            ...state.survey
          });

      commit(SET_SURVEY_ID, newDoc.id);

    }

  },

  resetSurveyId(store) {
    store.docID = null;
  },

  async saveAnswer({state, commit}, payload) {
    // payload = { 'page_number': 1, 'question_idx': 3, 'userAnswer': [...], 'question': {...}}

    console.log("In saveAnswer");
    // console.log(state.survey.quizList[payload.page_number-1].questions[payload.question_idx].userAnswer);
    console.log(payload.userAnswer);
    commit(UPDATE_SURVEY_ANSWERS, payload);
    commit(UPDATE_SURVEY_SCORE);
    // Save the profile in Firestore
    // console.log(state.survey.quizList[payload.page_number-1].questions[payload.question_idx].userAnswer);
    await db.collection('surveys').doc(state.docID).update({
            ...state.survey
          });
  },


};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/survey/index.js